import { translationNamespaces } from './locale.types';

export const supportedLanguages = ['en-US', 'es'] as const;

export type TranslationNamespace = (typeof translationNamespaces)[number];
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const COMMON_NAMESPACE: TranslationNamespace = 'common';
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-US';
